import React, { useState, useEffect } from 'react';
import { User, X } from 'lucide-react';
import SearchableMultiSelect from './SearchableMultiSelect';

const EditUserModal = ({ user, allPapers, onClose, onSave }) => {
  const [selectedPapers, setSelectedPapers] = useState([]);

  useEffect(() => {
    if (user) {
      setSelectedPapers(user.assignedPapers || []);
    }
  }, [user]);

  if (!user) return null;

  const handleSave = () => {
    onSave(user.email, selectedPapers);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div
        className="bg-white rounded-xl max-w-lg w-full flex flex-col shadow-2xl animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b border-slate-200">
          <h3 className="text-lg font-semibold text-slate-800 flex items-center gap-2">
            <User size={20} />
            Edit Assigned Papers
          </h3>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-slate-200 transition-colors"
          >
            <X size={20} className="text-slate-600" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-sm text-slate-600">
            You are editing the paper assignments for:
            <strong className="block text-base text-slate-800 mt-1">
              {user.email}
            </strong>
          </p>
          <SearchableMultiSelect
            options={allPapers}
            selectedOptions={selectedPapers}
            onChange={setSelectedPapers}
            isDisabled={false}
          />
        </div>
        <div className="flex justify-end items-center p-4 bg-slate-50 border-t border-slate-200 rounded-b-xl gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold text-sm"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;
